import React, { useState } from 'react';
import { Button, LinearProgress, TextField } from '@material-ui/core';

import { putRequest } from 'utils/api';
import styles from 'styles/components/milestones/Milestone.module.scss';

const GuaranteedGainsProgress = ({
  c4CampaignId,
  milestone,
  updateMilestone,
  influencerAssigned = false,
}) => {
  const [currentGains, setCurrentGains] = useState(milestone.guaranteed_gains_current);
  const [isTouched, setIsTouched] = useState(false);

  if (!milestone.guaranteed_gains || !milestone.initial_screenshot.url) return null;

  const hasError = currentGains < 0;

  const disabled =
    ['awaiting_approval', 'approved'].includes(milestone.status) ||
    !milestone?.delivery_screenshot.url;

  const handleSave = () => {
    putRequest({
      endpoint: `/milestones/${milestone.id}/update_guaranteed_gains_count`,
      data: {
        guaranteed_gains_current: currentGains,
      },
    })
      .then(() => {
        updateMilestone(milestone.id, currentGains);
      })
      .catch(() => {});
  };

  const progress = (milestone.guaranteed_gains_current / milestone.guaranteed_gains_max) * 100;

  return (
    <div>
      <h3 className={styles.heading}>Guaranteed Gains Progress: {progress.toFixed(2)}%</h3>

      <LinearProgress
        className={styles.progress}
        variant="determinate"
        color="primary"
        value={progress > 100 ? 100 : progress}
      />

      <p className={styles.assetsImages}>
        {milestone.guaranteed_gains_current} of {milestone.guaranteed_gains_max} subs delivered
        {influencerAssigned && milestone.status !== 'approved' && !c4CampaignId && (
          <div
            style={{
              display: 'flex',
              marginTop: 20,
              justifyContent: 'space-between',
              gap: 5,
              width: '100%',
            }}
          >
            <TextField
              style={{ width: '80%' }}
              type="text"
              name="guraranteed_gains_current"
              value={currentGains === 0 ? null : currentGains}
              placeholder="Please input the number of subs delivered"
              onChange={e => setCurrentGains(e.target.value)}
              variant="outlined"
              error={hasError && isTouched}
              helperText={hasError && isTouched ? 'must be greater than or equal to 0' : ''}
              disabled={disabled}
              onFocus={() => setIsTouched(true)}
            />

            <Button
              disabled={hasError || disabled || currentGains == 0}
              size="small"
              onClick={handleSave}
              variant="contained"
              color="primary"
              style={{ height: 40 }}
              className={styles.saveBtn}
            >
              Save
            </Button>
          </div>
        )}
      </p>
    </div>
  );
};

export default GuaranteedGainsProgress;
